import React, { Fragment } from "react";
import { CSVLink } from "react-csv";
import { Download as DownloadIcon } from "react-feather";
import classnames from "classnames";

export interface CsvColumnAccessorFunc<T> {
  (item: T): any;
}

export interface CsvColumn<T> {
  title: string;
  accessor: string | CsvColumnAccessorFunc<T>;
}

export interface DownloadCsvProps<T> {
  title?: string;
  data: T[];
  columns: CsvColumn<T>[];
  filename: string;
  disabled?: boolean;
}

const DownloadCsv = <T extends object>(props: DownloadCsvProps<T>) => {
  const title = props.title ?? "Download";
  const filename = props.filename ?? "Download";

  const headings = props.columns.map(column => column.title);
  const rows = props.data.map(item =>
    props.columns.map(column =>
      typeof column.accessor === "function" ? column.accessor(item) : (item as any)[column.accessor]));

  const data = [headings, ...rows];

  return (
    <Fragment>
      <div className="download-csv text-center">
        <CSVLink
          filename={filename + ".csv"}
          className={classnames({
            "btn btn-sm btn-primary d-flex align-items-center": true,
            "disabled": props.disabled || rows.length === 0,
          })}
          data={data}
        >
          <DownloadIcon size={14} />
          <span className="ml-1">{title}</span>
        </CSVLink>
      </div>
    </Fragment>
  );
};

export default DownloadCsv;
